module.exports = __webpack_public_path__ + "static/img/companyContact.79410359.jpg";